import React from "react";
import EnumSettingTable from "./EnumSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showEnumSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function EnumSetting() {
  const dispatch = useDispatch();
  const { enumSetting } = useSelector(responseSetting);
  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);
  React.useEffect(() => {
    dispatch(showEnumSetting());
  }, [dispatch]);

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>EnumSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>EnumSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <EnumSettingTable dataSource={enumSetting} />
        </div>
      </div>
    </>
  );
}
